import http from '../http-common';

class VotersDataService {
  getCountVoters(){
    return http.get("/voter/count-voters");
  }
}

export default new VotersDataService();